import ResponsiveImage from 'components/core/ResponsiveImage'
import Markdown from 'markdown-to-jsx'
import { BlogPostModel } from 'models/core/BlogPostModel'
import React, { Fragment, FunctionComponent } from 'react'
import dayjs from 'dayjs'

type Props = {
  post: BlogPostModel['data']
}

const FullBlogPost: FunctionComponent<Props> = (props) => {
  const authors = props.post.attributes.authors
  return (
    <Fragment>
      <div className="blog-details pt-60 lg:pt-56 text-lg text-[#333] leading-[34px] font-normal blog-prose">
        <div className="container max-w-[990px]">
          <h2 className="text-[#333] text-3xl leading-[38px]">{props.post.attributes.title}</h2>
          <div className="text-[#333] font-bold text-[14px] mb-14 block">
            {authors && !!authors.data.length && 
            <>
              By{' '}
              <span className='border-r border-solid border-black'>
                {authors.data.map((author, index) => (
                  <a key={index} className="text-[#666] font-normal pr-1" href="javascript:void(0);">
                  {author.attributes.firstName} {author.attributes.lastName}
                  {(index == authors.data.length - 1) ? '' : ','}
                </a>
              ))}
              </span>
            </>
            }
            <span>{' '}{dayjs(props.post.attributes.publishedAt).format('MMM DD YYYY')}</span>
          </div>
          <div className="mt-6">
            <Markdown>{props.post.attributes.content}</Markdown>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default FullBlogPost
